import './App.css';
import './index.css';

import Navbar from './component/Navbar';

import Home from './component/Home'

import Products from './component/Products'

import Product from './component/Product'

import Cart from './component/Cart'

import AboutDev from './component/AboutDev'

import { Redirect, Route, Switch } from 'react-router-dom';

function App() {
  return (
    <>
      <Navbar />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/products" component={Products} />
        <Route exact path="/products/:id" component={Product} />
        <Route exact path="/cart" component={Cart} />
        <Route exact path="/AboutDev" component={AboutDev} />


        <Redirect to="/" />
      </Switch>

    </>
  );
}

export default App;
